import { JobCard } from '@seek/job-card';
import { Box, Stack } from 'braid-design-system';

import { SearchResultPlaceholder } from '../SearchResultPlaceholder';

import * as styles from './index.css';

interface Props {
  id: string;
  serpDetails: any;
}

export const SearchResultPreview = ({ id, serpDetails }: Props) => {
  const {
    advertiserName,
    bullets,
    category,
    subcategory,
    displayPay,
    isFeatured,
    jobTitle,
    location,
    logo,
    salaryText,
    showBullets,
    searchDescription,
    tags,
    workArrangement,
  } = serpDetails;

  const bulletPoints = bullets.filter((bullet: string) => bullet.trim() !== '');

  return (
    <Box className={styles.container}>
      <Stack space="small">
        <SearchResultPlaceholder lines={2} first />
        <JobCard
          aria-label={jobTitle}
          {...(showBullets && { bulletPoints })}
          classificationLinks={[
            {
              name: category,
            },
            {
              name: subcategory,
            },
          ]}
          companyLink={{
            name: advertiserName,
          }}
          featureFlags={{
            isShowJobCardTeaserInSplitView: true,
            shouldOpenApplyInNewTab: false,
            remoteSearchFilterEnabled: true,
          }}
          id={id}
          isAuthenticated={false}
          isPremium={isFeatured}
          isSelected={false}
          jobDetailPageCardTitleOriginLink={{}}
          jobDetailPageJobCardOriginLink={{}}
          jobDetailPageLink={{}}
          jobLinkOnClick={function jobLinkOnClick() {}}
          jobMetaLinkOnClick={function jobMetaLinkOnClick() {}}
          jobTitle={[jobTitle]}
          locationLinks={[
            {
              name: location,
            },
          ]}
          locationMatch="Exact"
          onClick={function onClick() {}}
          {...(displayPay && { salaryDisplayLabel: salaryText })}
          saveJob={{
            isSaved: false,
            isApplied: false,
            returnUrl: '',
            toggleSavedJob: function toggleSavedJob() {},
          }}
          shouldAddFocusEffect={false}
          shouldAddHoverEffect={false}
          shouldAddOverlayLink={false}
          {...(logo && { srcLogo: logo.url })}
          teaser={searchDescription}
          tags={tags}
          workArrangement={workArrangement}
        />
        <SearchResultPlaceholder lines={2} last />
      </Stack>
    </Box>
  );
};
